import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetAccountCardsResponse } from './types/get-list-cards.type';

export const getAccountCards = async (): Promise<AxiosResponse<GetAccountCardsResponse>> => {
	const response = await api.get('/myaccount/config');

	return response;
};
